const BreadCrumbMappings = require('./mappings');
const NO_CRUMB_ROUTES = ['/customer_support/web/guest'];
const DEFAULT_ROUTE = '/customer_support';
const breadcrumnHelper = {
    noCrumbsRoute(url) {
        return NO_CRUMB_ROUTES.indexOf(url) != -1;
    },
    defaultCrumb() {
        return {
            'text': BreadCrumbMappings[DEFAULT_ROUTE],
            'url': DEFAULT_ROUTE,
            "path": DEFAULT_ROUTE
        }
    },
    articleCrumbQueryString() {
        return btoa(JSON.stringify([
            { "text": "Customer Support", "url": "/customer_support", "path": "/customer_support" },
            { "text": "FAQs", "url": "/faq", "path": "/faq" }
        ]));
    },
    articleCrumbQSWithoutFAQs() {
        return btoa(JSON.stringify([
            { "text": "Customer Support", "url": "/customer_support", "path": "/customer_support" }
        ]));
    }
}
module.exports = breadcrumnHelper;